(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "babel-runtime/helpers/extends", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/helpers/extends"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react);
    global.DownloadIconSvg = mod.exports;
  }
})(this, function (exports, _extends2, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DownloadIcon = function DownloadIcon(props) {
    return _react2.default.createElement(
      "svg",
      (0, _extends3.default)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 56,
        height: 56,
        viewBox: "0 0 56 56"
      }, props),
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "confirm-icon-a", cx: 28, cy: 28, r: 28 })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "confirm-icon-b", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#confirm-icon-a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", xlinkHref: "#confirm-icon-a" }),
        _react2.default.createElement(
          "g",
          { mask: "url(#confirm-icon-b)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(13 10)" },
            _react2.default.createElement("rect", { width: 27, height: 30, y: 4, fill: "#47506B", rx: 1 }),
            _react2.default.createElement("rect", { width: 27, height: 30, x: 2, y: 2, fill: "#757D99", rx: 1 }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: 6,
              y: 19,
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: 6,
              y: 23,
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: 6,
              y: 27,
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement(
              "g",
              { fill: "#FFF" },
              _react2.default.createElement("path", { d: "M13 7h5V0h-5zM15.5 15L23 7H8z" })
            )
          )
        )
      )
    );
  };

  exports.default = DownloadIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/DownloadIcon.svg.js
// module id = 2014
// module chunks = 1